(function () {
    'use strict';
    angular.module(modules.homeModule)
        .controller('statisticsController', controller);

    controller.$inject = ['$scope', '$location'];

    function controller($scope, $location) {

        var vm = this;
        vm.firstLoaded = true;
        vm.translation = resources;

        // Variables
        vm.alerts = [];
        var urlParams = $location.url().split('/');

        vm.tabsSetting = [];

        vm.onTabSelected = onTabSelected;

        // Main features
        $scope.$on("tabActived", function (evt, data) {
            if (vm.firstLoaded && data == 'statistics-tab') {
                initialize();
                vm.firstLoaded = false;
            }
        });

        function initialize() {
            buildTabsSetting();
            onTabSelected(1);
        }

        function buildTabsSetting() {
            vm.tabsSetting.push({
                name: resources.L.Statistics.useAndKeyValues,
                description: resources.L.Statistics.useAndKeyValues,
                href: 'dailyStatistics',
                icon: '',
                tabIndex: 1,
                active: true,
                count: 0,
                activatedClass: 'home-tab-active',
                hide: false,
                url: '/app/components/statistics/daily-statistics/daily-statistics.html',
                elementContentId: 'dailyStatistics'
            });
            vm.tabsSetting.push({
                name: resources.L.Statistics.folderStatistics,
                description: resources.L.Statistics.folderStatistics,
                href: 'folderStatistics',
                icon: '',
                tabIndex: 2,
                active: false,
                count: 0,
                activatedClass: 'home-tab-active',
                hide: false,
                url: '/app/components/statistics/folder-statistics/folder-statistics.html',
                elementContentId: 'folderStatistics'
            });
        }

        function onTabSelected(tabIndex) {
            var tab = vm.tabsSetting.find(x => x.tabIndex == tabIndex);
            setTimeout(function () {
                $scope.$apply(function () {
                    $scope.$broadcast("tabStatisticsActived", tab.href);
                });
            }, 100);
        }
    }
})();